import DimShower from "./DimShower";
import { useDispatch} from 'react-redux';

import { useContext, useEffect, useLayoutEffect, useRef } from 'react';
import CropWrapper from './CropWrapper';
import RotationContainerSvg from './RotationContainerSvg';

import { TemporaryAdjustmentsContext, FigureChannelAdjustmentContext } from './Contexts';
import useElementDims from './useElementDims';

const HTML_IMG_ID = "main-crop-preview";
const bounds = (ref) => ref.current.getBoundingClientRect();

export default function CroppableImage({
  atns,
  imgContainerRef, 
  imgRef, 
  imageSetId,
  imageId,
  temporaryAdjustments,
  temporaryAnnotationProperties,
  notifyAnnotationPropertyChange,
  crop,
  height,
  highlight,
  width,
  interactive,
  imageToRender,
  onEvent,
  extraContainerStyle,
}){

  let croppableImageRef = useRef();
  let croppableImageContainerRef = useRef();


  let dispatch = useDispatch();

  let containerWidth = (imgContainerRef && imgContainerRef.current && imgContainerRef.current.getBoundingClientRect().width);

  useEffect(() => {

    if( croppableImageRef && croppableImageRef.current ){

      let previewImageDiv = document.getElementById(HTML_IMG_ID);

      if( previewImageDiv ){
        let imgBounds = previewImageDiv.getBoundingClientRect();
        //setImgContainerBounds(imgBounds);
      }
    }
    

  },[ croppableImageRef.current ])

  let heightMultiplier = height || 1;
  let imgContainerRefHeight = containerWidth * heightMultiplier;

  let containerBounds = useElementDims(croppableImageContainerRef);
 
  let cropHeightAspect = crop.height / crop.width;

  let imageContainerWidth,imageContainerHeight, imageContainerLeft, imageContainerTop;
  if( containerBounds ){
    let cWidth = containerBounds.width;
    let cHeight = containerBounds.height;

    if( cWidth * cropHeightAspect >= cHeight ){
      imageContainerWidth = cHeight / cropHeightAspect;
      imageContainerHeight = cropHeightAspect * imageContainerWidth;
    }else{
      imageContainerWidth = cWidth;
      imageContainerHeight = cropHeightAspect * imageContainerWidth;
    }

    imageContainerLeft = (containerBounds.x + 0.5 * (containerBounds.width - imageContainerWidth));
    imageContainerTop = (containerBounds.y);
  }

  let imgContainerBounds = {
    width:imageContainerWidth, height:imageContainerHeight,
    left:imageContainerLeft, top:imageContainerTop
  }

  const { filterId } = useContext(FigureChannelAdjustmentContext);

  let backgroundImage = imageToRender ?
    <TemporaryAdjustmentsContext.Provider value={{ temporaryAdjustments, interactive }}>{imageToRender}</TemporaryAdjustmentsContext.Provider> : (
    <CropWrapper 
      canClickToRetryDownload={true}
      temporaryAdjustments={temporaryAdjustments}
      stack={["CroppableImage"]}
      inlineCrop={crop}
      imgRef={croppableImageRef}
      overflow={false}
      htmlImageId={HTML_IMG_ID}
      imageId={imageId} 
      draggable={false} imageSelectable={false} 
    />
  )

  return (

    <>

      <div class="flex-expand rel croppable-image-container" ref={croppableImageContainerRef} style={{
          //width:'100%',
          //height:'100%', 
          minHeight:0,
          minWidth:0,
          ...extraContainerStyle,
      }}>

        <div
          imageView={"image-to-annotate"}
          ref={imgContainerRef}
          style={{ 
            width:imageContainerWidth,
            height:imageContainerHeight,
            background:'rgba(238,238,238)',
            position: "relative",
            left:'50%',
            transform:'translate(-50%,0)',
            zIndex:3,

          }}
        >
          {interactive!==false && containerBounds && <RotationContainerSvg {
            ...{

              onEvent,
              imageViewTransformation:crop,
              atns,
              interactive,
              highlight,
              temporaryAnnotationProperties,
              imgRef,
              notifyAnnotationPropertyChange,
              imageSetId,
              imgContainerBounds,
              crop,
            } }/>}
          {backgroundImage}

                  </div>
      </div>
    </>
  )
}

